import {
  DeleteReservedSpaceDocument,
  DeleteReservedSpaceMutation,
  DeleteReservedSpaceMutationResult,
  DeleteReservedSpaceMutationVariables,
} from "../GeneratedGraphQL";

import { defaultOrganisation } from "./organisation";
import { defaultReservedSpaceId } from "./createReservation";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";
import { successReservedSpaceId } from "./createBookingsForBookingTool";

export const defaultDeleteReservedSpaceVariables: DeleteReservedSpaceMutationVariables =
  {
    organisationId: defaultOrganisation._id,
    reservedSpaceId: defaultReservedSpaceId,
  };

const defaultDeleteReservedSpaceResult: Partial<DeleteReservedSpaceMutationResult> =
  {
    data: { deleteReservedSpace: defaultReservedSpaceId },
  };

export const defaultDeleteReservedSpaceRequest: MockedResponse<DeleteReservedSpaceMutation> =
  {
    request: {
      query: DeleteReservedSpaceDocument,
      variables: defaultDeleteReservedSpaceVariables,
    },
    result: defaultDeleteReservedSpaceResult,
  };

export const defaultDeleteSuccessReservedSpaceVariables: DeleteReservedSpaceMutationVariables =
  {
    organisationId: defaultOrganisation._id,
    reservedSpaceId: successReservedSpaceId,
  };

export const successDeleteReservedSpaceRequest: MockedResponse<DeleteReservedSpaceMutation> =
  {
    request: {
      query: DeleteReservedSpaceDocument,
      variables: defaultDeleteSuccessReservedSpaceVariables,
    },
    result: defaultDeleteReservedSpaceResult,
  };

export const failedToDeleteReservedSpaceRequest: MockedResponse<DeleteReservedSpaceMutation> =
  {
    request: {
      query: DeleteReservedSpaceDocument,
      variables: defaultDeleteReservedSpaceVariables,
    },
    result: {
      errors: [new GraphQLError("Unable to delete reserved space")],
    },
  };
